class ClipBoardButton extends HTMLElement {
  constructor() {
    super();
    this.value = this.getAttribute('value');
    this.popoverEl = this.querySelector('.popover');
  }
  connectedCallback() {
    this.addEventListener('click', () => {
      if (navigator.canShare) {
        const text = this.querySelector('.title')?.textContent;
        const data = {
          url: this.value,
          text: text,
        };
        navigator.share(data);
      } else {
        navigator.clipboard.writeText(this.value);
        this.popoverEl.removeAttribute('aria-hidden');
        setTimeout(() => {
          this.popoverEl.setAttribute('aria-hidden', true);
        }, 2500);
      }
    });
  }
}

customElements.define('clipboard-button', ClipBoardButton);
